// The player's bikes (bike plan 6: any number, one of each design), as plain data so node tests cover it.
// gameState.raw.bikes is keyed by design id, one entry per owned bike: {owned, type, design, grease, paid,
// parked_scene, parked_x, parked_y, parked_facing}. A bike is named by its design id everywhere; its kind
// (`type`, 'pink' / 'blue') still picks its art, size and speed.

const KINDS = ['pink', 'blue'];

/** The owned bikes, in key order: [{id, type, design, ...entry}]. */
export function ownedBikes(bikes) {
  return Object.entries(bikes ?? {})
    .filter(([, b]) => b?.owned)
    .map(([id, b]) => ({ ...b, id, type: b.type, design: b.design ?? id }));
}

/** The kind of the bike `id`, or null when there is no such bike. */
export function bikeKind(bikes, id) {
  return bikes?.[id]?.type ?? null;
}

// Which bike a saved ride flag means. A tab that rode before bike plan 6 saved the bike's KIND ('pink' / 'blue'):
// that is the player's one bike of that kind, and nothing when they have several or none. Until the state has
// loaded (bikes undefined) the stored id is kept.
export function resolveRideId(stored, bikes) {
  if (!stored) return null;
  if (bikes === undefined) return stored;
  if (bikes?.[stored]?.owned) return stored;
  if (KINDS.includes(stored)) {
    const mine = ownedBikes(bikes).filter((b) => b.type === stored);
    return mine.length === 1 ? mine[0].id : null;
  }
  return null;
}
